import { useEffect } from 'react';
import { CardTapPage } from 'airkey-mfa-react';
import { WEB_NFC_PERMISSIONS_VIDEO } from './model/constants';
import i18nConfig from './i18nConfig';

const nonce = [0xab, 0xcd, 0x00, 0x05];
const nonceString = [...new Uint8Array(nonce)]
  .map((x) => x.toString(16).padStart(2, '0'))
  .join('')
  .toUpperCase();

// Set this to the string 'v2' to send the nonce on card read
const appletVersion: string = 'v1'; //eslint-disable-line

interface TapCardPageProps {
  onRead: (data: string) => unknown;
  onClose: () => void;
  processId: string;
}

export interface NRExperimentInfo {
  experimentKey: string | undefined;
  policyProcessId: string | undefined;
  variant: string | undefined;
}

export const TapCardPage = ({ onRead, onClose }: TapCardPageProps) => {
  /* c8 ignore next */
  const nonceValue = appletVersion === 'v2' ? nonceString : ''; //appletVersion is hardcoded so it can be skipped from coverage.

  const onReadCardTap = (cardReadData: string) => {
    onRead(cardReadData);
  };

  useEffect(() => {
    // This will automatically trigger the reading on component mounts. Trigger this after Apex response is received.
    (
      document.querySelector(
        'button.card-tap-start-verify-button',
      ) as HTMLButtonElement
    )?.click();
  }, []);

  return (
    <div
      className="security-page"
      style={{
        margin: '48px auto',
      }}
      data-testid="TapCardPage--Wrapper"
    >
      <div className="airkey-mfa-header-fade-in1">
        <CardTapPage
          nonce={nonceValue}
          onCardTapResult={onReadCardTap}
          i18nConfig={i18nConfig}
          webNfcPermissionsVideo={WEB_NFC_PERMISSIONS_VIDEO}
          close={onClose}
        />
      </div>
    </div>
  );
};
